import { useState } from "react";
import { GraduationCap } from "lucide-react";
import { CONTACTS_NETWORK, NEWS_CITATIONS } from "../../data/presentationData";
import { SW, CitationBar } from "./shared";

export function Section7() {
  const [selC, setSelC] = useState(null);
  return (
    <SW id="section-7">
      <div className="mb-8 stagger-1">
        <span className="text-[#005BBB] text-xs font-bold tracking-[0.2em] uppercase" style={{ fontFamily: 'var(--font-body)' }}>The Network</span>
        <h2 className="text-4xl md:text-5xl font-bold mt-3 text-slate-900">40+ Contacts. Warm Pathways Mapped.</h2>
        <p className="text-slate-500 mt-4 text-lg max-w-3xl" style={{ fontFamily: 'var(--font-body)' }}>Every connection researched, outreach sequence designed for maximum impact across 8 weeks. FSU is 4 hours from NCF with 3 existing Ukraine MOUs.</p>
      </div>
      <div className="grid grid-cols-[170px_1fr] gap-6 stagger-2">
        <div className="flex items-start justify-center pt-4">
          <div className="bg-[#1B365D] text-white rounded-2xl p-5 text-center w-full border-2 border-[#C5A258]/30">
            <GraduationCap className="w-8 h-8 mx-auto mb-2 text-[#C5A258]" /><div className="font-bold text-sm">NCF</div><div className="text-xs text-slate-300" style={{ fontFamily: 'var(--font-body)' }}>Klingenberg</div>
          </div>
        </div>
        <div className="space-y-4">
          {CONTACTS_NETWORK.rings.map((ring, ri) => (
            <div key={ri}>
              <div className="flex items-center gap-2 mb-2"><div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: ring.color }} /><span className="font-semibold text-sm text-slate-700">Phase {ring.phase}: {ring.label}</span><span className="text-xs text-slate-400 ml-1" style={{ fontFamily: 'var(--font-body)' }}>Wk {ring.weeks}</span><span className="text-[10px] text-slate-400 ml-auto">{ring.contacts.length} contacts</span></div>
              <div className="grid grid-cols-3 lg:grid-cols-4 gap-2">
                {ring.contacts.map((c, ci) => {
                  const key = `${ri}-${ci}`;
                  const act = selC === key;
                  return (
                    <div key={ci} data-testid={`contact-${ri}-${ci}`} className={`contact-card rounded-xl border p-3 cursor-pointer ${act ? "border-blue-400 shadow-md bg-blue-50" : "border-slate-200 hover:border-slate-300 bg-white"}`} onClick={() => setSelC(act ? null : key)}>
                      <div className="font-semibold text-sm text-slate-900" style={{ fontFamily: 'var(--font-display)' }}>{c.name}</div>
                      <div className="text-[11px] text-slate-500 mt-0.5" style={{ fontFamily: 'var(--font-body)' }}>{c.org} {'\u2014'} {c.role}</div>
                      {act && (
                        <div className="mt-2 pt-2 border-t border-slate-200 tooltip-enter">
                          <p className="text-xs text-slate-700 leading-relaxed" style={{ fontFamily: 'var(--font-body)' }}>{c.value}</p>
                          {c.email && <p className="text-xs text-blue-600 mt-1 font-medium">{c.email}</p>}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-8 bg-white rounded-2xl p-6 border border-slate-200 stagger-3">
        <h3 className="font-bold text-slate-900 mb-4">8-Week Outreach Timeline</h3>
        <div className="flex gap-2">
          {CONTACTS_NETWORK.rings.map((ring, i) => (
            <div key={i} className="flex-1 rounded-xl p-3 text-center" style={{ backgroundColor: ring.color + "12", borderLeft: `3px solid ${ring.color}` }}>
              <div className="font-bold text-xs" style={{ color: ring.color }}>Phase {ring.phase}</div>
              <div className="text-[10px] text-slate-500 mt-1" style={{ fontFamily: 'var(--font-body)' }}>Wk {ring.weeks}</div>
              <div className="text-[10px] text-slate-400 mt-0.5" style={{ fontFamily: 'var(--font-body)' }}>{ring.label}</div>
              <div className="text-[10px] text-slate-400 font-medium mt-1">{ring.contacts.length} contacts</div>
            </div>
          ))}
        </div>
      </div>
      <CitationBar citations={NEWS_CITATIONS.network} />
    </SW>
  );
}
